export default __webpack_public_path__ + "static/media/surfers.24d6ff3c.png";